import { LegalDocumentProps } from "components/LegalDocuments/interface";
import { IAddress } from "./Address";
import { ISeller } from "./Seller";

export interface ICustomer {
    identifier?: string;
    companyName?: string;
    fantasyName?: string;
    documentNumber?: string;
    phone?: string;
    areaCode?: string;
    comercialEmail?: string;
    financialEmail?: string;
    customerBus?: Array<string>;
    id?: string;
    customerId?: string;
    contactName?: string;
    address?: IAddress;
    seller?: ISeller;
    crmCustomerCode?: string;
    lastBillingDays?: number,
    valueCreditNotes?: number;
    enterpriseCode?: number;
    madePurchaseIn?: string[];
    legalDocumentsAttachments?: LegalDocumentProps[];
    useElectronicBillLading?: boolean;
    controlledMedicine?: boolean;
    controlledMedicineUpdatedAt?: string;
    legalDocuments?: LegalDocumentProps[];
}

export enum EnterpriseCodeEnum {
    ENTERPRISE_PFS = 98
}